import React from "react";

import PageComponent from "components/Page";
import Button from "components/Button";
import ButtonIcon from "components/ButtonIcon";
import Search from "components/Search";
import Select from "components/Select";
import MultiSelect from "components/MultiSelect";
import TabsSwitch from "components/TabsSwitch";

import CalendarAdvanced from "pages/appointment/components/CalendarAdvanced";
import ControlDate from "pages/appointment/components/ControlDate";
import ListBuffer from "pages/appointment/components/ListBuffer";
import ClientsSearch from "pages/appointment/components/ClientsSearch";
import ScheduleView from "pages/appointment/components/ScheduleView/MainView";
import AddPopup from "pages/appointment/components/AddPopup";
import Doctors from "pages/appointment/components/Doctors";
import CancelAppDialog from "pages/appointment/components/CancelAppDialog";
import OrthopedicDialog from "pages/appointment/components/OrthopedicDialog";
import InvoiceDetailDialog from "pages/client/components/InvoiceDetailDialog";

import { ReactComponent as BuferIcon } from 'icons/components/clipboard.svg';
import { ReactComponent as ScheduleIcon } from 'icons/components/scheduleAdjustment.svg';

import './index.less';
import './themes/default.less';

export default class Appointment extends PageComponent {
    constructor(props) {
        super(props);

        const urlDateStr = this.state.urlProps.date;
        const urlDate = this._helper.date.create(urlDateStr);
        const date = this._helper.date.clearTime(urlDate?.getTime() ? urlDate : null);
        const currentTime = parseInt(this._helper.storage("apptSelectedTimePeriod")) || 60;

        this.state = {
            ...this.state,
            buferOpened: false,
            canceledMode: false,
            date,
            search: "",
            currentDoctor: null,
            currentClient: this.getLastClientId(),
            visits: [],
            schedules: [],
            intervalSchedules: [],
            dateSchedules: [],
            filteredCabinets: [],
            selectedCabinets: [],
            uncheckedCabinets: [],
            buffer: [],
            currentDays: 3,
            currentTime,
            editDoctorsMode: false
        };

        this.timeItems = [
            { id: 5, name: `5 ${this.tr("main.min")}` },
            { id: 10, name: `10 ${this.tr("main.min")}` },
            { id: 15, name: `15 ${this.tr("main.min")}` },
            { id: 30, name: `30 ${this.tr("main.min")}` },
            { id: 60, name: `1 ${this.tr("main.h")}` },
            { id: 120, name: `${this._helper.string.capitalize(this.tr("main.oneD"))}` }
        ];

        this.daysItems = [
            { id: 1, name: `1 ${this.tr("main.oneD")}` },
            { id: 2, name: `2 ${this.tr("main.manyD")}` },
            { id: 3, name: `3 ${this.tr("main.manyD")}` },
            { id: 4, name: `4 ${this.tr("main.manyD")}` },
            { id: 7, name: `7 ${this.tr("main.manyDays")}` },
        ];

        this.doctorsTab = 0;
    }

    componentDidLoad() {
        this.getSchedules();
    }

    printDoctor() {
        const { currentDoctor, date } = this.state;

        this.printShow("Doctors_schedule", {
            date: this._helper.date.toDateServerStr(date),
            doctorId: currentDoctor + ""
        });
    }

    get rightPopupsMap() {
        return {
            "addApp": AddPopup
        };
    }

    get dialogsMap() {
        return {
            "cancelApp": CancelAppDialog,
            "invoiceDetailDialog": InvoiceDetailDialog,
            "orthopedic": OrthopedicDialog,
        };
    }

    async getSchedules() {
        this._helper.showLoading();

        const resp = await this._request.doctorsScheduleShortList.getAllByClinic(this.state.clinicId);
        const schedules = (resp?.data || []).map(it => {
            it.beginDate = this._helper.date.toLocal(it.beginDate);
            it.endDate = this._helper.date.toLocal(it.endDate);
            return it;
        });

        this.setState({ schedules }, this.getVisits.bind(this));

        this._helper.hideLoading();
    }

    async getVisits() {
        this._helper.showLoading();

        const { clinicId, date, currentDoctor, currentDays, schedules, cabinets, uncheckedCabinets, canceledMode, buferOpened } = this.state;
        let fromDate = this._helper.date.clearTime(date);

        this._helper.setPageProps({ date: this._helper.date.toStr(date, "YYYY-MM-DD") });
        let toDate = this._helper.date.setTime(new Date(fromDate), "23:59");
        if (currentDoctor)
            toDate = this._helper.date.addDays(fromDate, currentDays);

        const visitsResp = await this._request.visits.get(clinicId, currentDoctor, fromDate, toDate, canceledMode);
        let visits = visitsResp?.data || [];

        const list = [...new Set(visits?.filter(it => it?.client?.id).map(it => it.client.id))];

        const resp = await this._request.visits.getFutureVisitForClients(list);
        const futureVisits = resp?.data || [];
        visits = visits.map(it => {
            if (futureVisits.some(vis => vis?.client?.id === it?.client?.id))
                it.futureVisitExist = futureVisits.find(vis => vis.client.id === it.client.id);
            else
                it.futureVisitExist = false;
            return it;
        });

        const from = fromDate.getTime();
        const to = new Date(toDate).getTime();
        const dateSchedules = [];

        const intervalSchedules = schedules.filter(it => {
            const start = this._helper.date.fromStr(it.beginDate);
            const startTime = start.getTime();
            const end = this._helper.date.fromStr(it.endDate);
            const endTime = end.getTime();

            if (this._helper.date.equealDates(fromDate, start))
                dateSchedules.push(it);

            return startTime >= from && endTime <= to;
        });

        const selectedCabinets = [];
        const filteredCabinets = cabinets.filter(it => {
            /*if (it.domainId !== clinicId || !intervalSchedules.find(sh => it.id === sh.cabinetId))
                return false;*/
            if (!intervalSchedules.find(sh => it.id === sh.cabinetId))
                return false;

            if (!uncheckedCabinets.includes(it.id))
                selectedCabinets.push(it.id);

            return true;
        }).map(it => {
            return { id: it.id, name: it.title };
        });

        let currDoctorFuture = [];
        if (currentDoctor) {
            const startDate = new Date().setHours(0, 0);
            currDoctorFuture = schedules.filter(it => new Date(it.beginDate) > startDate && currentDoctor === it.doctorId)
                .map(it => {
                    const freeTime = this._helper.date.getFreeTimeForDoctor(it, visits);
                    return { date: new Date(it.beginDate), freeTime };
                });
        }

        this.setState({
            visits,
            dateSchedules,
            intervalSchedules,
            filteredCabinets,
            selectedCabinets,
            currDoctorFuture
        }, () => {
            if (buferOpened)
                this.getBufferData();
        });

        this._helper.hideLoading();
    }

    reload() {
        window.location.reload();
    }

    async updVis(id, info, cb) {
        this._helper.showLoading();
        await this._request.visits.update(id, info);
        this._helper.hideLoading();

        if (cb?.apply)
            cb();

        this.refreshVisits();

    }

    async updateVisit(id, info, cb) {
        const { clinicId } = this.state;
        const { doctorId, beginDate, endDate, cabinetId } = info;

        this._helper.showLoading();
        const checkExistVisits = await this._request.visits.checkExistVisitsBeforeInsert(clinicId, doctorId, beginDate, endDate, id, cabinetId);

        this._helper.hideLoading();
        if (checkExistVisits) {
            this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("Ошибка обновления расписания"),
                text: this.tr("Расписание обновилось, перенос расписания невозможен"),
            });
        } else if (id && info)
            this.updVis(id, info, cb);

        /*if (cb?.apply)
            cb();

        this.refreshVisits();*/
    }

    async getBufferData() {
        this._helper.showLoading();

        const { clinicId } = this.state;
        const resp = await this._request.visits.getBuffer(clinicId);
        const buffer = resp?.data || [];

        this._helper.hideLoading();

        this.setState({ buferOpened: true, buffer });
    }

    refreshVisits() {
        this.state.urlProps.stageId = null;
        this.setState({ visits: [] }, this.getVisits.bind(this));
    }

    getLastClientId() {
        const last = this._helper.storage("apptLastActiveClient");
        return last ? parseInt(last) : null;
    }

    setLastClientId(id) {
        const lastId = this.getLastClientId();
        const currentClient = lastId === id ? null : id;

        this._helper.storage("apptLastActiveClient", currentClient);

        this.setState({ currentClient });
    }

    writeToBuffer(info) {
        const { clinicId } = this.state;

        const beginDate = this._helper.date.create("1970-01-01");
        const endDate = this._helper.date.addMins(beginDate, 30);

        this.openRightPopup("addApp", { domainId: clinicId, cabinetId: null, status: "WI_BUFFER_CREATED", beginDate, endDate }, info, this.refreshVisits.bind(this));
    }

    onClinicChanged() {
        this.setState({
            currentDoctor: null,
            intervalSchedules: [],
            dateSchedules: [],
            schedules: [],
            visits: [],
        }, () => {
            this.getSchedules();
            if (this.scheduleView) {
                this.scheduleView.resetScrollAndPosition();
            }
        });
    }

    onDaysChanged(currentDays) {
        this.setState({ currentDays }, this.getVisits.bind(this));
    }

    setToCalendarCurrentDate(date) {
        this.calendar.onChange(this.calendar.state.firstSelected, this._helper.date.clearTime(date));
    }

    onCalendarChanged(date) {
        if (date.getTime() === this.state.date.getTime())
            return;

        if (this.scheduleView) {
            this.scheduleView.resetScrollAndPosition();
        }

        this.setState({
            date,
            intervalSchedules: [],
            dateSchedules: [],
            visits: [],
        }, this.getVisits.bind(this));
    }

    onCurrentDoctorChanged(id) {
        let { currentDoctor, dateSchedules } = this.state;

        currentDoctor = currentDoctor === id ? null : id;

        if (this.doctorsTabs?.state)
            this.doctorsTab = this.doctorsTabs.state.index || 0;

        if (currentDoctor && !this.doctorsTab) {
            if (!dateSchedules.find(sh => sh.doctorId === id))
                this.doctorsTab = 1;
        }

        this.setState({
            currentDoctor,
            search: "",
            visits: [],
        }, this.getVisits.bind(this));
    }

    onCancelModeChanged() {
        const canceledMode = !this.state.canceledMode;

        this.setState({
            canceledMode,
            visits: [],
        }, this.getVisits.bind(this));
    }

    onCabinetChange(ids) {
        const { filteredCabinets, uncheckedCabinets } = this.state;

        filteredCabinets.forEach((it, i) => {
            if (!ids.includes(it.id) && !uncheckedCabinets.includes(it.id))
                uncheckedCabinets.push(it.id);
            else if (ids.includes(it.id) && uncheckedCabinets.includes(it.id))
                uncheckedCabinets.splice(uncheckedCabinets.indexOf(it.id), 1);
        });

        this.setState({ uncheckedCabinets });
    }

    onCurrentTimeChange(currentTime) {
        this._helper.storage("apptSelectedTimePeriod", currentTime);

        this.setState({ currentTime });
    }

    toggleBuffer() {
        if (!this.state.buferOpened)
            this.getBufferData();
        else
            this.setState({ buferOpened: false, buffer: [] });
    }

    renderDoctors(isCurrent) {
        const { search, currentDoctor, dateSchedules } = this.state;

        return (
            <Doctors
                search={search.toLowerCase()}
                activeId={currentDoctor}
                customProps={{ isCurrent, dateSchedules }}
                onClick={this.onCurrentDoctorChanged.bind(this)}
            />
        );
    }

    renderCalendarZone() {
        const { date, currentDays, currentDoctor, search, currDoctorFuture } = this.state;

        const isCurrent = this._helper.date.equealDates(date, new Date());
        const dateLabel = "^" + this.tr("main.onTheDate") + " " + this._helper.date.toStr(date, "D MMMM");

        return (
            <>
                <div className="mainLabel label text pageTitle">{this.tr("main", "appoint")}</div>
                <div className="today text blockTitle hand" onClick={this.setToCalendarCurrentDate.bind(this, null)}>
                    {this.tr("main", "now") + ", " + this._helper.date.toStr(new Date(), "D MMMM")}
                </div>
                <CalendarAdvanced
                    ref={el => this.calendar = el}
                    interval={currentDoctor ? currentDays : 1}
                    value={this.state.date}
                    selectedDays={currDoctorFuture}
                    onChange={this.onCalendarChanged.bind(this)}
                />
                <div className="doctorLabel label text blockTitle">{this.tr("main", "list")}</div>
                <Search
                    value={search}
                    placeHolder={"main.searchDoctor"}
                    onChange={this.changeState.bind(this, "search")}
                />
                {!search ? (
                    <TabsSwitch
                        ref={el => this.doctorsTabs = el}
                        tab={this.doctorsTab}
                        tabs={[isCurrent ? "main.now1" : dateLabel, "main.all"]}
                        onChange={this.onCurrentDoctorChanged.bind(this, null)}
                        pages={[
                            this.renderDoctors.bind(this, true),
                            this.renderDoctors.bind(this, false),
                        ]}
                    />
                ) : (
                    <div className="tabsSwitch">{this.renderDoctors(false)}</div>
                )}
            </>
        );
    }

    renderSearchZone() {
        const { currentClient, canceledMode, buferOpened } = this.state;

        return (
            <div className="searchZone flex centerV gap16">
                <ClientsSearch
                    selectedItem={currentClient}
                    onItemSelectionClick={this.setLastClientId.bind(this)}
                    writeToBuffer={this.writeToBuffer.bind(this)}
                />
                <div className="flex gap16">
                    <Button
                        type={"stroke"}
                        size={"small"}
                        label={"main.delItems"}
                        active={canceledMode}
                        onClick={this.onCancelModeChanged.bind(this)}
                    />
                    <Button
                        type={"stroke"}
                        size={"small"}
                        label={"main.record"}
                        icon={<BuferIcon />}
                        active={buferOpened}
                        onClick={this.toggleBuffer.bind(this)}
                    />
                </div>
            </div>
        );
    }

    renderActionsZone() {
        const { date, filteredCabinets, selectedCabinets, currentDoctor, currentDays, currentTime, editDoctorsMode } = this.state;

        const cabNum = selectedCabinets.length;
        let cabLabel = "main.manyCabH";
        if (cabNum > 0) {
            if (cabNum === 1)
                cabLabel = "1 " + this.tr("main.oneCab");
            else if (cabNum < 5)
                cabLabel = cabNum + " " + this.tr("main.manyCab");
            else
                cabLabel = cabNum + " " + this.tr("main.manyCabA");
        }

        return (
            <div className="padding flex centerV gap16">
                <div className="flex1">
                    <ControlDate
                        doctor={this.getDoctorById(currentDoctor)}
                        days={currentDays}
                        value={date}
                        onChange={this.setToCalendarCurrentDate.bind(this)}
                    />
                </div>
                <div className="flex gap16">
                    {currentDoctor ? (
                        <Select
                            value={currentDays}
                            placeHolder={"main.days"}
                            items={this.daysItems}
                            onChange={this.onDaysChanged.bind(this)}
                        />
                    ) : (
                        <MultiSelect
                            min={1}
                            selected={selectedCabinets}
                            fixedHolder={cabLabel}
                            items={filteredCabinets}
                            onChange={this.onCabinetChange.bind(this)}
                        />
                    )}
                    <Select
                        value={currentTime}
                        placeHolder={"main.time"}
                        items={this.timeItems}
                        onChange={this.onCurrentTimeChange.bind(this)}
                    />
                    <Button
                        type="stroke"
                        size="small"
                        tooltip="app.scheduleAdjustment"
                        active={editDoctorsMode}
                        icon={<ScheduleIcon />}
                        onClick={this.toggleState.bind(this, "editDoctorsMode")}
                    />
                    {!!currentDoctor && (
                        <ButtonIcon name="print" onClick={this.printDoctor.bind(this)} />
                    )}
                </div>
            </div>
        );
    }

    renderPage() {
        const { buferOpened, currentTime, buffer } = this.state;
        const { stageId, forClientId } = this.state.urlProps;
        const bufferCl = buferOpened ? " opened" : "";
        const timeLabel = this.timeItems.find(it => it.id === currentTime)?.name || "";

        return (
            <>
                <div className="calendarZone padding scrolling">
                    {this.renderCalendarZone()}
                </div>
                <div className="flex1 flex col">
                    {this.renderSearchZone()}
                    <div className="flex1 flex minH0">
                        <div className="flex1 flex col">
                            {this.renderActionsZone()}
                            <div className="mainZone flex1 flex minH0 hidden">
                                <ScheduleView
                                    ref={el => this.scheduleView = el}
                                    info={this.state}
                                    timeLabel={timeLabel}
                                    getDoctorById={this.getDoctorById.bind(this)}
                                    openAddVisit={this.openRightPopup.bind(this, "addApp")}
                                    stageId={stageId}
                                    forClientId={forClientId}
                                    updateVisit={this.updateVisit.bind(this)}
                                    refreshVisits={this.refreshVisits.bind(this)}
                                    getSchedules={this.getSchedules.bind(this)}
                                />
                            </div>
                        </div>
                        <div className={"buferZone flex" + bufferCl}>
                            <div className="flex1 padding scrolling">
                                <ListBuffer
                                    info={this.state}
                                    items={buffer}
                                    updateVisit={this.updateVisit.bind(this)}
                                    openDialog={this.openDialog.bind(this)}
                                    getDoctorById={this.getDoctorById.bind(this)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

